export default game => {
  const teamMap = {
    a: game.team_a_id,
    b: game.team_b_id
  };
  let object = {};
  for (let { market_name: market, ...odd } of game.odds) object[market] = object[market] ? object[market].concat([odd]) : [odd];
  const results = {};
  for (let market in object) {
    results[market] = {};
    if (market === 'tr_1x2' || market === 'int_1x2') {
      object[market] = ['team_a', 'draw', 'team_b']
      .map(possibility => game.odds.find(item => item.market_name === market && item.outcome === possibility && item.best))
      .map(object => ({
        odd: object.odd,
        provider: object.provider_name,
        winner: { team_a: game.team_a_id, team_b: game.team_b_id, draw: null }[object.outcome]
      }));
    } else if (market === 'dv_1x2') {
      let odds = object[market]
      .map(odd => {
        return {
          ...odd,
          odd: odd.odd,
          provider: odd.provider_name,
          handicapped_team: teamMap[odd.handicap_team_a ? 'a' : 'b']
        };
      });
      let groups = [];

      for (let odd of odds) {
        let index = groups.findIndex(item => item.length && item[0].handicap === odd.handicap && item[0].handicapped_team === odd.handicapped_team);
        if (index < 0) {
          groups.push([odd]);
        } else {
          groups[index].push(odd);
        }
      }

      groups = groups
      .filter(item => !item.find(sub => sub.odd < 1.2))
      .sort((a, b) => b[0].handicap - a[0].handicap);

      object[market] = groups.length ? groups[0] : [];
      if (object[market].length) {
        const odd = object[market][0];
        // get one provider // quick fix to avoid handicap problems
        let provider = odd.provider;
        object[market] = object[market].filter(o => o.provider === provider);
        // end quick fix
        object[market] = object[market].sort((a, b) => a.outcome_order - b.outcome_order);
        results[market].title = game[`team_${ odd.handicap_team_a ? 'a' : 'b' }_name`] + ' +' + odd.handicap;
      }
    }

    results[market] = {
      ...results[market],
      odds: object[market]
    };
  }
  return results;
};
